export const initOneTrust = (domainId = 'b4a2f8d6-8f06-4476-8cc5-87b66347ac6f-test') => {
    const loadScript = () => {
        const { head } = document;
        const script = document.createElement('script');

        script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        script.type = 'text/javascript';
        script.setAttribute('data-document-language', 'true');
        script.setAttribute('data-domain-script', domainId);
        script.setAttribute('data-attempt', domainId);

        head.insertBefore(script, head.firstChild);
    };

    if (domainId) {
        loadScript();
    } else {
        const errorMessage = 'OneTrust Error: No ID for this domain';

        console.error(errorMessage);
    }
};
